export default "__VITE_ASSET__f2dbaed0__"